import React from "react";

export type ILazerIconProps = {};

const LazerIcon: React.FC<ILazerIconProps> = () => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={49.767}
   height={49.768}
   viewBox="0 0 49.767 49.768"
  >
   <path
    data-name="Path 380"
    d="M40.947 1.2a6.76 6.76 0 00-9.075 1.28l-5.561 6.8L6.126 29.459A5.852 5.852 0 005.18 36.5l-1.362 1.178A11.013 11.013 0 000 46.019v3.749h2.927v-3.749a8.088 8.088 0 012.8-6.126L7.225 38.6a5.854 5.854 0 007.181-.865l20.181-20.178L41.385 12a6.758 6.758 0 001.652-8.473 3.139 3.139 0 013.8 3.071v17.984a3.137 3.137 0 01-3.133 3.133h-8.575a5.855 5.855 0 000 11.71h5.855V36.5h-5.855a2.928 2.928 0 110-5.855h8.577a6.068 6.068 0 006.061-6.061V6.6a6.063 6.063 0 00-8.82-5.4zM8.196 35.669a2.926 2.926 0 010-4.14l1.035-1.035 4.14 4.14-1.035 1.035a2.926 2.926 0 01-4.14 0zm7.245-3.105l-4.14-4.14L27.394 12.33l4.14 4.14zM40.933 6.953a3.791 3.791 0 01-1.4 2.777l-5.83 4.77-4.337-4.337 4.769-5.828a3.832 3.832 0 015.68-.283 3.792 3.792 0 011.118 2.901z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 381"
    d="M6.733 42.14h4.391v2.927H6.733z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 382"
    d="M14.052 42.14h4.391v2.927h-4.391z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 383"
    d="M21.37 42.14h4.391v2.927H21.37z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 384"
    d="M28.689 42.14h4.391v2.927h-4.391z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 385"
    d="M36.008 42.14h4.391v2.927h-4.391z"
    fill="#7c7c7c"
   />
   <path
    data-name="Path 386"
    d="M43.326 42.14h4.391v2.927h-4.391z"
    fill="#7c7c7c"
   />
  </svg>
 );
};

export { LazerIcon };
